import { render, staticRenderFns } from "./WorkerStatusScroll.vue?vue&type=template&id=67008b2f&scoped=true&"
import script from "./WorkerStatusScroll.vue?vue&type=script&lang=js&"
export * from "./WorkerStatusScroll.vue?vue&type=script&lang=js&"
import style0 from "./WorkerStatusScroll.vue?vue&type=style&index=0&id=67008b2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67008b2f",
  null
  
)

export default component.exports